import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '../src/index.css';
import { Suspense, } from 'react';
import { ConfigProvider, } from './common/config/ConfigProvider.js';
import { FrontendUpdateToastContainer, } from './components/FrontendUpdateToastContainer.js';
import { RouterProvider, } from './router/RouterProvider.js';
export function App() {
    const searchParams = new URLSearchParams(window.location.search);
    const hasNoUpdate = searchParams.has('noupdate');
    return (_jsxs(Suspense, { fallback: _jsx("div", {}), children: [!hasNoUpdate && _jsx(FrontendUpdateToastContainer, {}), _jsx(ConfigProvider, { children: _jsx(RouterProvider, {}) })] }));
}
//# sourceMappingURL=App.js.map